import axios from "axios";
import AuthService from "./AuthService";
import { getEncryptedData } from "./custom.js";
import Router from "../router";

export default class BaseService extends AuthService {
  static token = "";
  static axiosClient = {};
  static getAxiosClient() {
    const axiosClient = axios;
    axiosClient.defaults.headers.common.user_key = process.env.VUE_APP_USER_KEY;
    return axiosClient;
  }
  /* eslint-disable */
  static getSchemePlanningClient() {
    const axiosClient = axios.create({
      baseURL: process.env.VUE_APP_COMMON_API_ROOT,
    });
    axiosClient.defaults.headers.common.user_key = process.env.VUE_APP_USER_KEY;

    axiosClient.defaults.headers.common.Authorization =
      "Bearer " + localStorage.getItem("token");
    axiosClient.defaults.headers.common["biz-unit"] =
      localStorage.getItem("bizUnit");
    axiosClient.defaults.headers.common["revision-version-id"] =
      localStorage.getItem("revisionID"); 

    axiosClient.interceptors.response.use(undefined, (error) => {
      return new Promise(async (resolve, reject) => {
        switch (error.response?.status) {
          case 401:
            const originalConfig = error.config;
            this.authenticateToken();
            originalConfig.headers["Authorization"] =
              "Bearer " + localStorage.getItem("token");
            return resolve(axiosClient(originalConfig));
            break;
          case 406:
            if(error.response?.data.message === 'user_not_allowed')
              window.location.href = '#/1/unauthorized';
          default:
            return reject(error);
        }
      });
    });
    axiosClient.interceptors.request.use(function (config) {
      
      if (!!localStorage.getItem('ptyCd')) {
        config.headers['ptyCd'] = localStorage?.getItem('ptyCd');
        let enryptEncRecord =
          localStorage.getItem('ptyCd') +
          '::' +
          localStorage.getItem('useremail');
        config.headers['ptyCdEnc'] = getEncryptedData(enryptEncRecord);
      }

      let currentUrl = config.url;
      if (currentUrl && !currentUrl.includes("enc=")) {
        if (currentUrl && currentUrl.includes("?")) {
          config.url = config.url + "&enc=" + getEncryptedData(config.url);
        } else if (currentUrl && currentUrl.includes("&")) {
          config.url = config.url + "&enc=" + getEncryptedData(config.url);
        } else {
          config.url = config.url + "?enc=" + getEncryptedData(config.url);
        }
      }
      return config;
    });
    return axiosClient;
  }
  static getDMSAxiosClient() {
    const axiosClient = axios.create({
      baseURL: process.env.VUE_APP_DMS_API_ROOT,
    });
    axiosClient.defaults.headers.common.user_key =
      process.env.VUE_APP_DMS_USER_KEY;
    axiosClient.defaults.headers.common.Authorization =
      "Bearer " + localStorage.getItem("token");
    axiosClient.interceptors.response.use(undefined, (error) => {
      return new Promise(async (resolve, reject) => {
        switch (error.response?.status) {
          case 401:
            const originalConfig = error.config;
            this.authenticateToken();
            originalConfig.headers["Authorization"] =
              "Bearer " + localStorage.getItem("token");
            return resolve(axiosClient(originalConfig));
            break;
          default:
            return reject(error);
        }
      });
    });
    axiosClient.interceptors.request.use(function (config) {
      let currentUrl = config.url;
      if (currentUrl && currentUrl.includes("?")) {
        config.url = config.url + "&enc=" + getEncryptedData(config.url);
      } else if (currentUrl && currentUrl.includes("&")) {
        config.url = config.url + "&enc=" + getEncryptedData(config.url);
      } else {
        config.url = config.url + "?enc=" + getEncryptedData(config.url);
      }
      return config;
    });

    return axiosClient;
  }
  static getDMSReportAxiosClient() {
    const axiosClient = axios.create({
      baseURL: "https://dms-be-sit.apps.dms-nonprod-01.siel.com/",
    });
    axiosClient.defaults.headers.common.user_key =
      "5c61eac90f63925fe5aa2dffc623e22d";
    axiosClient.defaults.headers.common.Authorization =
      "Bearer " + localStorage.getItem("sitToken");
    axiosClient.defaults.headers.common["biz-unit"] =
      localStorage.getItem("bizUnit");

    return axiosClient;
  }
  static getCommunicationClient() {
    const axiosClient = axios.create({
      baseURL: process.env.VUE_APP_COMMON_API_ROOT + "/communication/ims",
    });
    axiosClient.defaults.headers.common.user_key = process.env.VUE_APP_USER_KEY;
    axiosClient.defaults.headers.common.Authorization =
      "Bearer " + localStorage.getItem("token");
    axiosClient.defaults.headers.common["biz-unit"] =
      localStorage.getItem("bizUnit");
    axiosClient.defaults.headers.common["revision-version-id"] =
      localStorage.getItem("revisionID");

    return axiosClient;
  }
  static getDMSTokenClient() {
    const axiosClient = axios.create({
      baseURL: process.env.VUE_APP_DMS_API_ROOT,
    });
    axiosClient.defaults.headers.common.user_key =
      process.env.VUE_APP_DMS_USER_KEY;
    axiosClient.interceptors.response.use(undefined, (error) => {
      return new Promise(async (resolve, reject) => {
        switch (error.response?.status) {
          case 403:
            super.doLogout();
            break;
          default:
            return reject(error);
        }
      });
    });
    return axiosClient;
  }
  static authenticateToken() {
    super.generateToken();
  }
}
